import React from 'react';
import { Button } from '@mui/material';

export default function Input({ objValue, onChange, index, deleteField}) {

  const { docName, docDescription, value } = objValue;
    return (
        <div className="flex items-center justify-between border-b border-gray-200 py-4">
            <div className="flex-1">
                <div htmlFor={docName} className=" font-medium text-gray-900 break-words leading-relaxed max-w-xs">{docName}</div>
                <div htmlFor={docDescription} className=" mt-1 text-gray-500 break-words leading-relaxed max-w-5xl">{docDescription}</div>
            </div>
            <div className="ml-4">
                <Button
                    variant="outlined"
                    color="error"
                    className="w-20 h-8"
                    onClick={(e) => deleteField(e, index)}
                >
                    Delete
                </Button>
            </div>
        </div>
    );
};

/* export default function Input({ objValue, onChange, index, deleteField}) {
  const { docName, docDescription, value } = objValue;
 
  return (
    <div className="input-group" >
    <div className="lab1">
      <label style={{ fontWeight: 'bold' }} htmlFor={docName}>{docName} :</label>
      </div>
      <div className="lab2">
      <pre style={{ fontFamily: 'system-ui', minWidth: '500px' }} htmlFor={docDescription}>{docDescription}</pre>
      </div>
     
        <div className="lab3" style={{ marginLeft: '100px' }}>
      
            <Button variant="outlined" color="error"  style={{width:'70px', height:'20px'}} onClick={(e) => deleteField(e, index)}>Delete</Button>
            </div>
        
      </div>
   // </div>
  );
}
 */
